const GRANT_KEY = 'kandor.counselor.loginGrant'
const PENDING_KEY = 'kandor.counselor.pendingGrant'

const canUseStorage = () =>
	typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined'

const readJson = key => {
	if (!canUseStorage()) return null
	try {
		const raw = window.sessionStorage.getItem(key)
		if (!raw) return null
		return JSON.parse(raw)
	} catch {
		return null
	}
}

const writeJson = (key, value) => {
	if (!canUseStorage()) return
	try {
		window.sessionStorage.setItem(key, JSON.stringify(value))
	} catch {
		/* ignore quota / private mode */
	}
}

const removeKey = key => {
	if (!canUseStorage()) return
	try {
		window.sessionStorage.removeItem(key)
	} catch {
		/* ignore */
	}
}

/**
 * Frontend-only continuity grant bound to a Clerk session identity.
 * Not a backend authorization substitute.
 */
export const setCounselorLoginGrant = ({ sessionId, userId, email } = {}) => {
	const sid = String(sessionId || '').trim()
	const uid = String(userId || '').trim()
	if (!sid || !uid) return
	writeJson(GRANT_KEY, {
		sessionId: sid,
		userId: uid,
		email: email ? String(email).trim().toLowerCase() : null,
		createdAt: Date.now(),
	})
}

export const clearCounselorLoginGrant = () => {
	removeKey(GRANT_KEY)
}

export const getCounselorLoginGrant = () => readJson(GRANT_KEY)

export const isCounselorLoginGrantValid = ({ sessionId, userId } = {}) => {
	const grant = getCounselorLoginGrant()
	if (!grant?.sessionId || !grant?.userId) return false
	const sid = String(sessionId || '').trim()
	const uid = String(userId || '').trim()
	if (!sid || !uid) return false
	return grant.sessionId === sid && grant.userId === uid
}

/** Persist pre-auth intent before OAuth redirect; finalized when Clerk session is known. */
export const setPendingCounselorGrant = ({ email, method } = {}) => {
	writeJson(PENDING_KEY, {
		email: email ? String(email).trim().toLowerCase() : null,
		method: method || null,
		createdAt: Date.now(),
	})
}

export const getPendingCounselorGrant = () => readJson(PENDING_KEY)

export const clearPendingCounselorGrant = () => {
	removeKey(PENDING_KEY)
}

/**
 * After OAuth/SSO callback: if a pending grant exists, bind it to the new session.
 */
export const finalizePendingCounselorGrant = ({ sessionId, userId } = {}) => {
	const pending = getPendingCounselorGrant()
	if (!pending) return false
	const sid = String(sessionId || '').trim()
	const uid = String(userId || '').trim()
	if (!sid || !uid) return false
	setCounselorLoginGrant({
		sessionId: sid,
		userId: uid,
		email: pending.email,
	})
	clearPendingCounselorGrant()
	return true
}

export const COUNSELOR_LOGIN_GRANT_KEY = GRANT_KEY
